/**
 * As contas da seleção de linhas da `Tabela` — puras, para a tabela só
 * desenhar. As chaves são as de `chaveDaLinha`, na ordem da tela, e só as que
 * podem ser marcadas.
 */

/**
 * Marca ou desmarca uma linha. Com Shift, o clique vale para o intervalo desde
 * a última linha clicada (a âncora), como no e-mail: o intervalo inteiro fica
 * como a linha clicada ficou.
 */
export function alternarMarcacao(
  marcadas: ReadonlySet<string>,
  chaves: readonly string[],
  chave: string,
  opcoes: { readonly ancora: string | null; readonly intervalo: boolean },
): ReadonlySet<string> {
  const marcar = !marcadas.has(chave);
  const proximas = new Set(marcadas);
  const de = opcoes.ancora === null ? -1 : chaves.indexOf(opcoes.ancora);
  const ate = chaves.indexOf(chave);

  const alvo =
    opcoes.intervalo && de !== -1 && ate !== -1
      ? chaves.slice(Math.min(de, ate), Math.max(de, ate) + 1)
      : [chave];
  for (const c of alvo) {
    if (marcar) proximas.add(c);
    else proximas.delete(c);
  }
  return proximas;
}

/** "Marcar todas": com todas marcadas, desmarca; senão, marca as que faltam. */
export function alternarTodas(
  marcadas: ReadonlySet<string>,
  chaves: readonly string[],
): ReadonlySet<string> {
  const todas = chaves.length > 0 && chaves.every((c) => marcadas.has(c));
  const proximas = new Set(marcadas);
  for (const c of chaves) {
    if (todas) proximas.delete(c);
    else proximas.add(c);
  }
  return proximas;
}

/**
 * Só o que ainda está na tela: a linha excluída, a que saiu do filtro ou ficou
 * em outra página deixa de contar — marcada e invisível, ela entraria na ação
 * sem ninguém ver. Devolve o mesmo conjunto quando nada mudou.
 */
export function podarMarcacao(
  marcadas: ReadonlySet<string>,
  chaves: readonly string[],
): ReadonlySet<string> {
  const visiveis = new Set(chaves);
  const ficam = [...marcadas].filter((c) => visiveis.has(c));
  return ficam.length === marcadas.size ? marcadas : new Set(ficam);
}
